import { useLocation } from "react-router-dom"
import './aulaLista.css'
import BackButton from "../../layout/BackButton"
import Relatorio from "../../layout/Relatorio/Relatorio"
import { GrDocumentDownload } from "react-icons/gr"
import { useEffect, useState } from "react"
import { getDocCollection, updateItem } from "../../../firebase/CRUD"
import { salvar } from "../../Forms/Cadastro"
import { useAuth } from "../../../hooks/AuthContext"
import { montarRelatorioDeAula, anexarDadosHierarquia } from "../../../firebase/relatorios"
import { rankearTurmasPorPercentual } from "../../../utils/rankings"
import { rankearTurmasPorOferta } from "../../../utils/rankings"
import RankingRelatorio from "../../layout/Ranking/RankingRelatorio"
// A estrutura real do dashboard (aproveitamento médio, alunos faltosos,
// contagens etc.) é calculada e persistida pelo backend em
// escolas/{idEscola}/dashboard/geral, disparada automaticamente sempre
// que um doc é escrito em `relatorio` (ver backend/dashboard.js). Este
// componente não precisa (e não deve) escrever nada em `dashboard`.

export default function RelatorioDetalhado(){
    const location = useLocation()
    const {usuario} = useAuth()
    const turmas = location.state?.listaTurmas
    const geral = location.state?.geral
    const dadosAula = location.state?.dadosAula

    const [rankingPercentual,setRankingPercentual] = useState()
    const [rankingOferta,setRankingOferta] = useState()
    // const []
    useEffect(()=>{
        setRankingPercentual(rankearTurmasPorPercentual(turmas,turmas.lenght))
        setRankingOferta(rankearTurmasPorOferta(turmas,turmas.lenght))
        const pegarTurmas = (turmasDaEscola)=>{
            // A lógica de agrupamento por faixa etária foi extraída para
            // src/firebase/relatorios.js (montarRelatorioDeAula), pra ser
            // reaproveitada também pela geração retroativa do relatório do
            // mês anterior (botão em RelatorioMensal.js) sem duplicar a
            // regra em dois lugares.
            const relatorioBase = montarRelatorioDeAula(turmas, turmasDaEscola, dadosAula,usuario.idEscola)
            // Anexa regionalId/geralId da escola (se vinculada a alguma),
            // pra que a Regional/Geral consigam ler este relatório — ver
            // firestore.rules e src/firebase/relatorios.js.
            anexarDadosHierarquia(relatorioBase, usuario.idEscola).then((relatorio)=>{
                salvar({
                    localstore:"relatorio",
                    item:relatorio,
                    idEscola:usuario.idEscola
                })
            })
        }
        if(dadosAula.situacao === "aberta" && usuario){
           
            getDocCollection("turmas",pegarTurmas,usuario.idEscola)
            let percentual = Number((100*geral.presencas)/geral.matriculados).toFixed(2)
            dadosAula.biblia = geral.biblias
            dadosAula.presencas = geral.presencas
            dadosAula.oferta = geral.totalOfertas
            dadosAula.revista = geral.revistas
            dadosAula.matriculados = geral.matriculados
            dadosAula.visitantes = geral.visitantes
            dadosAula.aproveitamento = percentual
            dadosAula.situacao = "fechada"
            updateItem(
                "aulas",
                dadosAula.id,
                dadosAula,
                usuario.idEscola
            )
        }
       
    },[usuario])



    return (
        <div className='relatorioConteiner'>
            <div className='relatorioDetalhado'>
                <div style={{
                    display:"flex",
                    width:"90%",
                    justifyContent:"space-between"
                }}>
                    <BackButton/>
                    <GrDocumentDownload
                    
                    size={30}/></div>
              
                <h2>Relatório Escola Bíblica</h2>
                <h3>Lição {dadosAula.licao}</h3>
                
            </div>
            <div className='relatoriosListas'>   
                <h3>Relatorio Geral</h3>
                <Relatorio aula={geral}/>
                <h2>Relatório por turmas</h2>
                { turmas.map((item,id)=>
                    <> 
                        <h3>{item.nome}</h3>
                        <Relatorio 
                            key={id}
                            aula={{
                                ausentes: item.ausentes,
                                biblias: item.biblias,
                                matriculados: item.matriculados,
                                presencas: item.presencas,
                                revistas: item.revistas,
                                totalOfertas: item.totalOfertas,
                                visitantes: item.visitantes
                            }}
                        />
                    </>
                )
                }
            </div>
            <div className="ranking">
                Classificação das turmas 
                <RankingRelatorio ranking={rankingPercentual} tipo={'Percentual'}/>

                <RankingRelatorio ranking={rankingOferta} tipo={'Oferta'}/>
                
                
            </div>
        </div>
    )
}